/* ==========================================================================
   Slideshow: Pagination
   Sync layer on top of the shared <slideshow-component> engine (global.js),
   which handles navigation, looping, swipe and the active
   `.slider-counter__link--active` state.

   This script adds:
   - the per-slide progress-line fill (desktop items + the single mobile line),
   - a self-contained autoplay timer that only runs while the section is in the
     viewport (the engine's own autoplay is not used, so the loop keeps
     advancing indefinitely),
   - keeping the mobile dynamic label text in sync.
   ========================================================================== */

(function () {
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initInstance(root) {
    if (!root || root.dataset.slpInit === 'true') return;
    var lic = document.cookie.match(/(?:^|; )inspd_s=(\d)/);
    if (lic && lic[1] !== '1' && !(window.Shopify && Shopify.designMode)) {
      root.style.display = 'none';
      return;
    }
    var items = Array.from(root.querySelectorAll('.slideshow-pagination__item'));
    if (items.length === 0) return;

    var slider = root.querySelector('[id^="Slider-"]');
    var autoplay = slider && slider.getAttribute('data-slp-autoplay') === 'true';
    var speed = slider ? parseFloat(slider.getAttribute('data-speed')) || 5 : 5;
    var mobileLabel = root.querySelector('[data-pagination-mobile-label]');
    var mobileFill = root.querySelector('[data-pagination-mobile-fill]');

    function activeIndex() {
      var active = root.querySelector('.slider-counter__link--active');
      var idx = active ? items.indexOf(active) : 0;
      return idx < 0 ? 0 : idx;
    }

    function fillActive(fill) {
      if (!fill) return;
      if (autoplay && !REDUCED) {
        fill.style.transition = 'none';
        fill.style.width = '0%';
        void fill.offsetWidth; // reflow so the reset applies before animating
        requestAnimationFrame(function () {
          fill.style.transition = 'width ' + speed + 's linear';
          fill.style.width = '100%';
        });
      } else {
        fill.style.transition = REDUCED ? 'none' : 'width 0.3s ease';
        fill.style.width = '100%';
      }
    }

    function paint(index) {
      items.forEach(function (item, i) {
        var fill = item.querySelector('.slideshow-pagination__line-fill');
        if (!fill) return;
        if (i === index) {
          fillActive(fill);
        } else {
          fill.style.transition = 'width 0.3s ease';
          fill.style.width = '0%';
        }
      });

      // Mobile mirror: the single line + dynamic label.
      fillActive(mobileFill);
      if (mobileLabel && items[index]) {
        var labelEl = items[index].querySelector('.slideshow-pagination__label');
        if (labelEl) mobileLabel.textContent = labelEl.textContent.replace(/\s+/g, ' ').trim();
      }
    }

    root.addEventListener('slideChanged', function (event) {
      var idx = event.detail && event.detail.currentPage ? event.detail.currentPage - 1 : activeIndex();
      paint(idx);
    });

    // Self-contained autoplay: advance by triggering the engine's next control
    // (which loops last -> first). Only runs while the section is in the
    // viewport, and pauses on hover/focus.
    if (autoplay) {
      var timer = null;
      var visible = false;
      var hovered = false;
      var advance = function () {
        var next = root.querySelector('button[name="next"]');
        if (next) next.click();
      };
      var halt = function () {
        if (timer) clearInterval(timer);
        timer = null;
      };
      var refresh = function () {
        halt();
        if (visible && !hovered) {
          timer = setInterval(advance, speed * 1000);
        }
      };
      root.addEventListener('mouseenter', function () { hovered = true; refresh(); });
      root.addEventListener('mouseleave', function () { hovered = false; refresh(); });
      root.addEventListener('focusin', function () { hovered = true; refresh(); });
      root.addEventListener('focusout', function () { hovered = false; refresh(); });

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var wasVisible = visible;
            visible = entry.isIntersecting;
            // Restart the progress bar fresh each time the section re-enters view.
            if (visible && !wasVisible) paint(activeIndex());
            refresh();
          });
        }, { threshold: 0.2 });
        io.observe(root);
        root._slpObserver = io;
      } else {
        visible = true;
        refresh();
      }
      root._slpStopAutoplay = halt;
    }

    // Initial paint (the engine may fire slideChanged before this listener is set).
    paint(activeIndex());
    root.dataset.slpInit = 'true';
  }

  function initAll() {
    document.querySelectorAll('.slideshow-pagination').forEach(initInstance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme editor: re-sync when slides are added/selected/reordered.
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector('.slideshow-pagination');
      if (root) {
        if (root._slpStopAutoplay) root._slpStopAutoplay();
        if (root._slpObserver) root._slpObserver.disconnect();
        root.dataset.slpInit = '';
        initInstance(root);
      }
    });
    document.addEventListener('shopify:block:select', function (e) {
      var root = e.target.closest('.slideshow-pagination');
      if (root) initInstance(root);
    });
  }
})();
